import { useState } from "react";
import { Plus } from "lucide-react";
import { FAQS } from "../config";
import { useReveal } from "../hooks/useReveal";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const headRef = useReveal();
  const listRef = useReveal();

  return (
    <section id="faq" className="py-32 relative">
      <div className="container mx-auto px-6">
        <div ref={headRef} className="reveal mb-20 text-center">
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6">
            Questions? <span className="text-[#C9ED00]">We got you.</span>
          </h2>
        </div>

        <div ref={listRef} className="reveal max-w-3xl mx-auto space-y-4">
          {FAQS.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className="border-b border-white/5">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between py-8 bg-transparent border-0 text-left cursor-pointer group"
                >
                  <span className="text-lg font-medium text-white group-hover:text-amber-400 transition-colors">
                    {faq.q}
                  </span>
                  <Plus
                    className={`w-5 h-5 text-white/30 group-hover:text-white shrink-0 ml-6 transition-all duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <div
                  className="overflow-hidden transition-all duration-500 ease-in-out"
                  style={{
                    maxHeight: isOpen ? "500px" : "0",
                  }}
                >
                  <p className="pb-8 text-gray-400 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
